import './User.css'

import {Button, Col, Container, Input, Label, ListGroup, ListGroupItem, Row} from "reactstrap"
import { ERole, RoleDescription } from '../../enums/ERole';
import { useNavigate } from 'react-router-dom';
import { useCallback, useMemo, useState, useTransition } from 'react';
import { getUser } from '../../helpers/localStorage';
import { useTranslation } from 'react-i18next';
import { auto } from '@popperjs/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faSquare } from '@fortawesome/free-solid-svg-icons';

export default function User() {

    const user = getUser()
    const {t} = useTranslation(['user_info'])
    const navigate = useNavigate();

    const onPasswordEditClick = useCallback(()=>{
        navigate("/changePassword")
    }, []);

    const acceptFa = useMemo(() => {
        return <FontAwesomeIcon icon={faCheckSquare} color="green"/>
    }, [])

    const declineFa = useMemo(() => {
        return <FontAwesomeIcon icon={faSquare} color="red"/>
    }, [])

    const userHierarchyRoles = useMemo(() => {
        if (!user || !user.hierarchyRoles)
            return <></>;

        return (
            <>
                {
                    user.hierarchyRoles.map(
                        (role, index) => (
                            <ListGroupItem key={index} >
                                <Row divider>
                                    <Col lg={1} className='bold-text'>{role.level}</Col>
                                    <Col lg={3} >{role.name}</Col>
                                    <Col lg={1} className="d-flex justify-content-center">
                                        <Input type="switch" name='isPrimary' checked={role.isPrimary === true} />
                                    </Col>
                                    <Col lg={4} className="d-flex justify-content-center">
                                        <Input type="switch" name='informViaEmail' checked={role.informViaEmail === true} />
                                    </Col>
                                    <Col lg={3} >{role.informScheduleCron}</Col>
                                </Row>
                            </ListGroupItem>
                        )
                    )
                }
            </>
        )
    }, [user])

    const userRoles = useMemo(() => {
        if (!user || !user.hierarchyRoles)
            return <></>;

        return (
            <>
                {
                    user.roles.map(
                        (role, index) => (
                            <ListGroupItem key={index} >
                                <Row divider>
                                    <Col lg={1} className='bold-text'>{role.level}</Col>
                                    <Col lg={3} >{role.name}</Col>
                                </Row>
                            </ListGroupItem>
                        )
                    )
                }
            </>
        )
    }, [user])

    return (
        <>
            <div className="p-3"/>
            <div className="p-3">
                <Container className="gy-2">
                    <Row tag="h3" className='text-align-start mx-3 header-opacity'>
                       {t('My Account', { ns: 'common' })}
                    </Row>
                    <br/>
                    <Row className='my-1 m-3'>
                        <Col sm={3}  className="text-align-start light-text bold">
                            <Label for="userName"> {t('username')}</Label>
                        </Col>
                        <Col className="text-align-start">
                            <Label>{user?.userName}</Label>
                        </Col>
                    </Row>
                    <Row className='my-1 m-3'>
                        <Col sm={3} className="text-align-start bold light-text">
                            <Label for="description">E-Mail</Label>
                        </Col>
                        <Col className="text-align-start">
                            <Label>{user?.email}</Label>
                        </Col>
                    </Row>
                    <Row className='my-1 m-3'>
                        <Col md={3} className="text-align-start bold light-text">
                            <Label for="description">{t('user_password')}</Label>
                        </Col>
                        <Col md={0} className="text-align-start">
                            <Label>***************</Label>
                        </Col>
                        <Col md={auto}>
                            <Button className='w-100 d-flex flex-column px-3' color='primary' onClick={onPasswordEditClick} style={{width:50}}>
                                <span className='fa fa-pencil'/>
                            </Button>
                        </Col>
                    </Row>
                    <Row className='m-2 mt-3' style={{background: "#0006", height:"1px"}}/>
                    <Row className='my-1 m-3'>
                        <Col sm={3} className="text-align-start">
                            <Label className='bold light-text my-0' for="description"> {t('roles')}</Label>
                        </Col>
                    </Row>
                    <Row className='my-3 m-3'>
                        <ListGroup>
                            <ListGroupItem>
                                <Row >
                                    <Col lg={1}>{t('Level', { ns: 'common' })}</Col>
                                    <Col lg={2}>{t('Name', { ns: 'common' })}</Col>
                                </Row>
                            </ListGroupItem>
                            {
                                userRoles
                            }
                        </ListGroup>
                    </Row>
                    <Row className='m-2' style={{background: "#0006", height:"1px"}}/>
                    <Row className='my-1 m-3'>
                        <Col sm={3} className="text-align-start">
                            <Label className='bold light-text my-0' for="description">{t('hierarchy_roles')}</Label>
                        </Col>
                    </Row>
                    <Row className='my-3 m-3'>
                        <ListGroup>
                            <ListGroupItem>
                                <Row >
                                    <Col lg={1}>{t('Level', { ns: 'common' })}</Col>
                                    <Col lg={3}>{t('Name', { ns: 'common' })}</Col>
                                    <Col lg={1} className="d-flex justify-content-center">{t('Primary', { ns: 'common' })}</Col>
                                    <Col lg={4} className="d-flex justify-content-center">{t('Inform Via Email', { ns: 'common' })}</Col>
                                    <Col lg={3}>{t('Inform Schedule', { ns: 'common' })}</Col>
                                </Row>
                            </ListGroupItem>
                            {
                                userHierarchyRoles
                            }
                        </ListGroup>
                    </Row>
                </Container>
            </div>
        </>
    )

}
